import Vue from "vue";
import axios from "axios";
import Vuex from "vuex";
import auth from "@/store/auth-sanctum";
//import activeSurvey from "@/store/active-survey.js";
//import * as user from "@/store/auth-passport.js";
import * as notification from "@/store/notification.js";
import VuexORMAxios from "@vuex-orm/plugin-axios";

//VUEX-ORM
import VuexORM from "@vuex-orm/core";
import { Database } from "@vuex-orm/core";
VuexORM.use(VuexORMAxios, { axios });

//Import Models and Register them in Vuex-ORM
const database = new Database();
import User from "@/models/User";
database.register(User);

import Survey from "@/models/Survey";
database.register(Survey);

import Button from "@/models/Button";
database.register(Button);

import Step from "@/models/Step";
database.register(Step);

import Option from "@/models/Option";
database.register(Option);

import Response from "@/models/Response";
database.register(Response);

import Visitor from "@/models/Visitor";
database.register(Visitor);

import VisitorField from "@/models/VisitorField";
database.register(VisitorField);

//import Todo from '@/models/Todo'
//database.register(Todo)

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [VuexORM.install(database)],
  modules: {
    notification,
    auth,
    //survey
  },
  state: {},
  mutations: {},
  actions: {},
  getters: {},
});
